import React, { lazy } from "react";
import { RuleCreationTypeSelectorPage } from "./rule-creation/rule-creation-type-selector/RuleCreationTypeSelectorPage";
import { CashPoolingIcon } from "./shared/CashPoolingIcon";

// Lazy load components for each entrypoint
const OwnerListPage = lazy(() =>
  import("./owner-list/OwnerListPage").then((m) => ({ default: m.OwnerListPage })),
);
const RuleListPage = lazy(() =>
  import("./rule-list/RuleListPage").then((m) => ({ default: m.RuleListPage })),
);
const RuleEditPage = lazy(() =>
  import("./rule-edit/RuleEditPage").then((m) => ({ default: m.RuleEditPage })),
);
const RuleCreationFormPage = lazy(() =>
  import("./rule-creation/rule-creation-form/RuleCreationFormPage").then(
    (m) => ({ default: m.RuleCreationFormPage }),
  ),
);

const CashPoolingCredentialsPage = lazy(() =>
  import("./cash-pooling-credentials/CashPoolingCredentialsPage").then((m) => ({ default: m.CashPoolingCredentialsPage })),
);

const TransferHistoryPage = lazy(() =>
  import("./transfer-history/TransferHistoryPage").then((m) => ({ default: m.TransferHistoryPage })),
);

/**
 * Cash Pooling feature routes configuration
 *
 * Route structure:
 * - /cash-pooling/ -> list of owners (supports ?search=query)
 * - /cash-pooling/:ownerId -> list of rules for a specific owner
 * - /cash-pooling/:ownerId/rules/:ruleId/edit -> edit a specific rule
 * - /cash-pooling/rule-creation -> create a new rule
 */

// Export all routes as a single array for easier integration
export const getCashPoolingRoutes = () => [
  {
    // List of owners - /cash-pooling/
    path: "",
    key: "cash-pooling", // Use parent key for permissions
    label: "Cash Pooling",
    description: "A forma inteligente de transferir recursos.",
    element: <OwnerListPage />,
    icon: <CashPoolingIcon />,
  },
  {
    path: "rule-creation",
    key: "cash-pooling-rule-creation",
    label: "Criação de Regra",
    hiddenPageTitle: true,
    element: <RuleCreationTypeSelectorPage />,
  },
  {
    path: "rule-creation/minimum",
    label: "Regra de Caixa mínimo",
    key: "cash-pooling-rule-creation-minimum",
    element: <RuleCreationFormPage />,
    hiddenPageTitle: true,
  },
  {
    path: "rule-creation/excess",
    label: "Regra de Saldo Excedente",
    key: "cash-pooling-rule-creation-excess",
    element: <RuleCreationFormPage />,
    hiddenPageTitle: true,
  },
  {
    path: "rule-creation/fixed",
    label: "Regra de Valor fixo",
    key: "cash-pooling-rule-creation-fixed",
    element: <RuleCreationFormPage />,
    hiddenPageTitle: true,
  },
  {
    path: "transfer-history",
    label: "Histórico de transferências",
    key: "cash-pooling-transfer-history",
    element: <TransferHistoryPage />,
    hiddenPageTitle: true,
  },
  {
    // List of rules for a specific owner - /cash-pooling/:ownerId
    path: ":ownerId",
    label: "OWNER_NAME", // Dynamic label based on owner
    key: "cash-pooling-rule-list",
    element: <RuleListPage />,
    hiddenPageTitle: true,
  },
  {
    // Edit a specific rule - /cash-pooling/:ownerId/rules/:ruleId/edit
    path: ":ownerId/rules/:ruleId/edit",
    label: "Editar Regra",
    key: "cash-pooling-rule-edit",
    element: <RuleEditPage />,
    hiddenPageTitle: true,
  },
  {
    path: "credentials",
    label: "Credenciais",
    key: "cash-pooling-credentials",
    element: <CashPoolingCredentialsPage />,
    hiddenPageTitle: true,
  },
];
